import { IApplicationState } from '../../types/redux';

export function getSpecialStatusDisplay(state: IApplicationState) {
  const {
    newbuilding: { specialStatusDisplay },
  } = state;

  return specialStatusDisplay;
}
